module.exports = __webpack_public_path__ + "img/Banner_Leonos.447fda81.png";